var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArtsy = function SvgArtsy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v32h32V0zm2.31 2.33h27.38v27.35h-4.86v-6.26h-2.29v6.26H2.31zm8.06 3.28L5.66 17.72h2.43l1.27-3.41h4.56l1.25 3.41h2.43L12.89 5.61h-2.54Zm1.17 2.45 1.54 4.21H9.97l1.56-4.21Z"
  })));
};
export default SvgArtsy;